/**
 * PICKLIST DEL CRM API (gestione picklist) — allineata a PicklistsResourceImpl.java.
 *
 *   - GET   /list-type-definitions                                          -> Page<ListTypeDefinition>
 *   - POST  /list-type-definition/{id}/list-type-entries  ListTypeEntryInput (name)          -> ListTypeEntry
 *   - PATCH /list-type-entry/{listTypeEntryId}            ListTypeEntryInput (name, active)  -> ListTypeEntry
 */
import type { Page } from '@crm/contracts';
import { httpClient } from '../../api/httpClient';
import type {
  ListTypeDefinition,
  ListTypeEntry,
  ListTypeEntryCreatePayload,
  ListTypeEntryUpdatePayload,
} from './listTypeTypes';

export const listTypeApi = {
  // Sempre in italiano: la pagina modifica il nome italiano (it_IT), qualunque sia la lingua dell'app.
  list: () =>
    httpClient
      .get<Page<ListTypeDefinition>>('/list-type-definitions', { headers: { 'Accept-Language': 'it-IT' } })
      .then((r) => r.data.items),

  create: (listTypeDefinitionId: number, payload: ListTypeEntryCreatePayload) =>
    httpClient
      .post<ListTypeEntry>(`/list-type-definition/${listTypeDefinitionId}/list-type-entries`, payload)
      .then((r) => r.data),

  update: (listTypeEntryId: number, payload: ListTypeEntryUpdatePayload) =>
    httpClient.patch<ListTypeEntry>(`/list-type-entry/${listTypeEntryId}`, payload).then((r) => r.data),
};
